import { isAxiosError } from 'axios';
import { cartClient } from '../common/cartClient';
import type { GetUserMeResponse, UpdateUserRequest, UpdateUserResponse } from './utils/types';

class UserAPIClient {
  public async getMe(throwOnError = false): Promise<GetUserMeResponse> {
    try {
      const res = await cartClient.get('/user/me');
      return res.data;
    } catch (_e) {
      if (throwOnError && !(isAxiosError(_e) && _e.response?.status === 401)) {
        throw _e;
      }
      return null;
    }
  }

  public async updateUser(payload: UpdateUserRequest): Promise<UpdateUserResponse> {
    const res = await cartClient.put('/user/me', payload);
    return res.data;
  }
}

export const userAPIClient = new UserAPIClient();
